import {createActions} from 'client/framework';

const normalActions = [
  'RESET_STORE',
  'CONFIRM_WILL_LEAVE',
  'RESET_TOAST',
  'TOGGLE_ABANDON_MODAL_ACTIVE',
  'SET_NEXT_PATH_NAME',
  'SUBMIT_ASSIGNMENT'
];

export default createActions(null, normalActions);
